import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { getApiUrl } from '../../config/apiConfig';
import './Login.css';

const Login = () => {
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { setAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!usuario || !password) {
      setError('Todos los campos son obligatorios');
      setLoading(false);
      return;
    }

    try {
      // Registrar información de depuración
      console.log('Intentando login con:', { usuario });
      console.log('URL API:', getApiUrl('/auth/login'));
      
      const response = await fetch(getApiUrl('/auth/login'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          usuario, 
          password 
        }),
        credentials: 'include', // Para incluir cookies si tu API las usa
      });

      // Obtener directamente el JSON de la respuesta
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error de autenticación');
      }

      // Guardamos los datos de autenticación
      const authData = {
        token: data.token,
        user: data.user,
        role: data.user.rol
      };
      
      setAuth(authData);
      localStorage.setItem('auth', JSON.stringify(authData));
      
      console.log('Login exitoso, rol:', data.user.rol);
      
      // Redireccionar basado en el rol
      const rolesToRoutes = {
        'COCINERO': '/cocina-barra',
        'MOZO': '/mesas',
        'ENCARGADO': '/dashboard',
        'CAJERO': '/caja'
      };

      // Obtener la ruta correspondiente al rol o usar dashboard como fallback
      const redirectRoute = rolesToRoutes[data.user.rol] || '/dashboard';
      navigate(redirectRoute);
      
    } catch (err) {
      console.error('Error de autenticación:', err);
      setError(err.message || 'Error al iniciar sesión. Intente nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <div className="logo">
            <span className="logo-letter">R</span>
          </div>
          <h1>RealPOS</h1>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="usuario">Usuario</label>
            <input
              type="text"
              id="usuario"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              disabled={loading}
              placeholder="Ingrese su usuario"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              placeholder="Ingrese su contraseña"
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button" 
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;